import React from 'react'

import { ImCross } from "react-icons/im"
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai"

import { AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";

import { useAppContext } from 'AppContext'

import MistakeButton from 'MistakeButton'
import ImgDisplayer from 'ImgDisplayer';


const Popup = () => {

    const { setPopupOpen, currentPic, setCurrentPic, data, threshold } = useAppContext()

    const onClose = () => setPopupOpen(false)

    return (
        <div className="flex absolute left-0 top-0 justify-center items-center w-full h-full items-stretch">

            <div className="flex flex-col flex-grow shadow-xl p-4 mx-56 my-4 rounded-lg roundedfull-l z-30 bg-gray-700  shadow-2xl">
                <div className="flex justify-end items-end">
                    <div className="w-12 h-12 rounded-full flex justify-center items-center hover:bg-gray-800" onClick={onClose}>
                        <ImCross />
                    </div>
                </div>
                <div className="flex-grow">
                    <div className="flex justify-center">
                        <div className="max-w-3xl">
                            <ImgDisplayer src={currentPic.thumbnailUrl} box={currentPic.scratch >= threshold && currentPic.box} />
                        </div>
                    </div>

                    <div className="flex flex-col justify-center items-center mt-4">


                        {currentPic.scratch < threshold ? (
                            <div className="flex justify-center items-center text-6xl mb-2">
                                <AiFillCheckCircle />
                            </div>
                        ) : (
                                <div className="flex justify-center items-center text-6xl mb-2 text-red-400">
                                <AiFillCloseCircle />
                            </div>
                        )}

                        <p className="text-4xl font-bold">{`${Math.round(currentPic.scratch * 10) / 10} %`}</p>
                        <p>Scratch Detection confidence</p>
                    </div>
                </div>

                <div className="flex justify-center mb-4">
                    <MistakeButton onDelete={() => console.log('deleted')} />
                </div>


                <div className="w-full">
                    <div className="flex justify-center  items-center text-2xl">

                        <div className="rounded-full flex justify-center items-center hover:bg-gray-800 p-3 mr-4"
                            onClick={() => {
                                let idx = currentPic.id - 1
                                if (idx < 0) {
                                    idx = data.length + idx
                                }
                                setCurrentPic(data[idx])
                            }
                            }>
                            <AiOutlineLeft />
                        </div>


                        <div className="text-lg flex">
                            <p className="w-14">{currentPic.id + 1}</p>
                            <p className="ml-1 mr-8">/</p>
                            <p className="w-14">{data.length}</p>
                        </div>
                        <div className="rounded-full flex justify-center items-center hover:bg-gray-800 p-3"
                            onClick={() => setCurrentPic(data[(currentPic.id + 1) % data.length])}
                        >
                            <AiOutlineRight />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Popup
